import axios from "axios";

//TODO: Need to add annotation for this function once the API is ready

const optOutErrorAndReqPinApi =
    "/participant-web-services/rest/partialauth/optOutErrorRequestPin/:optOut";

export const optOutErrorAndReqPin = async (isOptOutParams) => {
    try {
        const response = await axios.post(
            `${window.__baseApiUrl__}${optOutErrorAndReqPinApi}`,
            { optOut: isOptOutParams },
            {
                headers: {
                    "Content-Type": "application/json"
                }
            }
        );
        return response.data;
    } catch (error) {
        return error;
    }
};
